import React from 'react';
import SeoMeta from '../components/SeoMeta';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import WeddingFAQ from '../components/WeddingFAQ';
import { weddingFaqSchema } from '../data/weddingFaqs';

export default function FaqPage() {
  return (
    <main className="bg-brand-vintage pb-0">
      <SeoMeta
        title="Wedding FAQs | Padua Hills Theatre"
        description="Answers about Padua Hills Theatre wedding cost, catering, guest counts, ceremony options, tours, and event planning in Claremont, California."
        schema={weddingFaqSchema}
      />
      <PageHero
        title="Frequently Asked Questions"
        subtitle="Clear details about planning your wedding at Padua."
        image="https://ik.imagekit.io/aeu02xvjgn/i-Wh5HSCQ-X3.jpg"
      />
      <div className="py-12">
        <WeddingFAQ />
      </div>
      <CTASection
        title="Still Have Questions?"
        desc="Talk with our team about your date, guest count, event plans, and next steps."
        primaryText="Book a Private Tour"
        primaryLink="/weddings/private-tour"
        secondaryText="Explore Wedding Pricing"
        secondaryLink="/weddings/investment"
      />
    </main>
  );
}